function getBaseTickFormat(d, domainDist) {
  const m = 1000000;
  const k = 1000;
  const dist = domainDist || d;

  if (dist >= m) return `${(Math.round((10 * d) / m) / 10).toLocaleString()} M`;
  if (dist >= k) return `${(Math.round((10 * d) / k) / 10).toLocaleString()} K`;
  return Math.round(d).toLocaleString();
}

export default getBaseTickFormat;
